import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import {htmlToText} from '../../../../helpers/utils'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

const useStyles = makeStyles(openQuestionStyles)

export default function OpenQuestion () {

  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.studentAnswer}>
      </Box>
    </Box>
  )
}

function openQuestionStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      minHeight: 300
    },
  }
}
